// extracted by mini-css-extract-plugin
export default {"root":"CommonIconEditModalCheckboxInfo_root__UXHpa","icon":"CommonIconEditModalCheckboxInfo_icon__ynVuQ","text":"CommonIconEditModalCheckboxInfo_text__4kBbA"};